import { setupYup } from 'config/yup';

const Yup = setupYup();

export const schema = Yup.object().shape({
  cadeirante_1: Yup.boolean().notRequired(),
  periodo_1: Yup.string().required(),
  cadeirante_2: Yup.boolean().notRequired(),
  periodo_2: Yup.string().nullable(),
});
